import { Organisation } from "../models/organisation";
import axiosConfig from "./axiosConfig";

interface OrganisationListResponse {
  organisations: Organisation[];
}

const getOrganisationList = async (
  authToken: string
): Promise<OrganisationListResponse> => {
  const { data } = await axiosConfig.get("/organisation", {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default getOrganisationList;
